import request from '@/utils/request'
const BASE_URL = '/GdPaper'

//指导教师
export default {
  list(data) {
    return request({
      url: BASE_URL + '/List',
      method: 'post',
      data
    })
  },
  info(id) {
    return request({
      url: BASE_URL + '/Info',
      method: 'get',
      params: { id }
    })
  },
  getYear() {
    return request({
      url: BASE_URL + '/GetSchoolYearList',
      method: 'get',
    })
  },
  save(data) {
    return request({
      url: BASE_URL + '/Save',
      method: 'post',
      data
    })
  },
  submit(data) {
    return request({
      url: BASE_URL + '/Submit',
      method: 'post',
      data
    })
  },
  cancel(data) {
    return request({
      url: BASE_URL + '/Cancel',
      method: 'post',
      data
    })
  },
  cancelPublish(data) {
    return request({
      url: BASE_URL + '/CancelPublish',
      method: 'post',
      data
    })
  },
  cancelExamine(data) {
    return request({
      url: BASE_URL + '/Back',
      method: 'post',
      data
    })
  },
  delete(data) {
    return request({
      url: BASE_URL + '/Delete',
      method: 'post',
      data
    })
  },
  examine(data) {
    return request({
      url: BASE_URL + '/Pass',
      method: 'post',
      data
    })
  },
  getMaxSn(schoolYear) {
    return request({
      url: BASE_URL + '/GetMaxSn',
      method: 'get',
      params: { schoolYear }
    })
  },
  UploadFileUrl: '/api/Common/UploadFile',
  import: "/api" + BASE_URL + "/Import",
  importEntrance: "/api" + BASE_URL + "/ImportEntrance",
  export(data,url) {
    return request({
      url: BASE_URL + '/Export',
      method: 'post',
      responseType: 'blob',
      data
    }).then(res => {
      var file = res.data;
      var disposition = res.headers['content-disposition'];
      // console.log('disposition', disposition);

      var fileName = "导出";
      if (disposition.lastIndexOf("filename*=UTF-8''") != -1) {
        var text = disposition.substr(disposition.lastIndexOf("filename*=UTF-8''") + ("filename*=UTF-8''").length)
        fileName = decodeURI(text);
      }

      if (navigator.msSaveBlob) {
        // IE10+下载
        navigator.msSaveBlob(file, fileName);
      } else {
        const elink = document.createElement("a");
        elink.download = fileName;
        elink.style.display = "none";
        elink.target = "_blank";
        elink.href = URL.createObjectURL(file);
        document.body.appendChild(elink);
        elink.click();
        URL.revokeObjectURL(elink.href); // 释放URL 对象
        document.body.removeChild(elink);
      }
      return Promise.resolve();
    });
  }
}